import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
export const renderRadioField = ({ input, meta, ...rest }) => (
  <ReactBootstrap.Form.Check {...input} {...rest} checked={input.checked} />
)

export const renderRadioFieldWithClickableLabel = ({
  input,
  label,
  type,
  name,
  value,
   meta: { touched, error, warning },
  ...rest
}) => (
    <ReactBootstrap.Row>
        {/*<ReactBootstrap.Col xs={12}>*/}
        {/*     {touched &&*/}
        {/*    ((error && <span className="text-danger">{error}</span>) ||*/}
        {/*        (warning && <span className="text-warning">{warning}</span>))}*/}
        {/*</ReactBootstrap.Col>*/}
          <ReactBootstrap.Col xs={12}>
  <ReactBootstrap.Form.Check style={{"margin":"8px",minWidth:"300px"}} type={type} id={`${label}-${type}`}>

    <ReactBootstrap.Form.Check.Input
      {...input}
      {...rest}
      checked={input.checked}
      type={type}

    />
    <ReactBootstrap.Form.Check.Label style={{ "display": 'block' }}
      {...input}
      {...rest}
      checked={input.checked}
    >
      {label}
    </ReactBootstrap.Form.Check.Label>
  </ReactBootstrap.Form.Check>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
)
